import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import useAuthStore from './store/authStore';
import AppLayout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import QRCodePage from './pages/QRCode';
import Logs from './pages/Logs';

// === @AGENT_A: 产品 + 仓库 + 采购 页面 ===
import Products from './pages/Products';
import Warehouse from './pages/Warehouse';
import StockIn from './pages/Warehouse/StockIn';
import StockOut from './pages/Warehouse/StockOut';
import Suppliers from './pages/Suppliers';
import Purchases from './pages/Purchases';
import PurchaseForm from './pages/Purchases/PurchaseForm';
import PurchaseDetail from './pages/Purchases/PurchaseDetail';

// === @AGENT_B: 报价 + 合同 页面 ===
import Quotations from './pages/Quotations';
import QuotationForm from './pages/Quotations/QuotationForm';
import QuotationDetail from './pages/Quotations/QuotationDetail';
import Contracts from './pages/Contracts';
import ContractForm from './pages/Contracts/ContractForm';
import ContractDetail from './pages/Contracts/ContractDetail';

// === @AGENT_C: 工作流配置 页面 ===
import WorkflowPage from './pages/Workflow';
import TemplateEdit from './pages/Workflow/TemplateEdit';

// === @AGENT_D: 企业微信回调 页面 ===
import WecomCallback from './pages/Auth/WecomCallback';

// === @AGENT_D: 通知中心 页面 ===
import NotificationsPage from './pages/Notifications';

// === @AGENT_D: 技术文档 页面 ===
import Documents from './pages/Documents';

// === @AGENT_E: 项目管理 页面 ===
import ProjectsPage from './pages/Projects';

// === 审计日志 ===
import AuditLogs from './pages/AuditLogs';

function ProtectedRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: '#07c160',
        borderRadius: 8,
      },
    }}>
      <AntApp>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/qrcode" element={<ProtectedRoute><QRCodePage /></ProtectedRoute>} />
            <Route path="/logs" element={<ProtectedRoute><Logs /></ProtectedRoute>} />

            {/* @AGENT_A: 产品 + 仓库 + 采购 路由 */}
            <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
            <Route path="/warehouse" element={<ProtectedRoute><Warehouse /></ProtectedRoute>} />
            <Route path="/warehouse/in" element={<ProtectedRoute><StockIn /></ProtectedRoute>} />
            <Route path="/warehouse/out" element={<ProtectedRoute><StockOut /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/purchases" element={<ProtectedRoute><Purchases /></ProtectedRoute>} />
            <Route path="/purchases/new" element={<ProtectedRoute><PurchaseForm /></ProtectedRoute>} />
            <Route path="/purchases/:id" element={<ProtectedRoute><PurchaseDetail /></ProtectedRoute>} />

            {/* @AGENT_B: 报价 + 合同 路由 */}
            <Route path="/quotations" element={<ProtectedRoute><Quotations /></ProtectedRoute>} />
            <Route path="/quotations/new" element={<ProtectedRoute><QuotationForm /></ProtectedRoute>} />
            <Route path="/quotations/:id" element={<ProtectedRoute><QuotationDetail /></ProtectedRoute>} />
            <Route path="/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
            <Route path="/contracts/new" element={<ProtectedRoute><ContractForm /></ProtectedRoute>} />
            <Route path="/contracts/:id" element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />

            {/* @AGENT_C: 工作流配置 (admin only) */}
            <Route path="/workflow" element={<ProtectedRoute><WorkflowPage /></ProtectedRoute>} />
            <Route path="/workflow/:code" element={<ProtectedRoute><TemplateEdit /></ProtectedRoute>} />

            {/* @AGENT_D: 企业微信回调 */}
            <Route path="/auth/wecom/callback" element={<WecomCallback />} />

            {/* @AGENT_D: 通知中心 */}
            <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />

            {/* @AGENT_D: 技术文档 */}
            <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />

            {/* @AGENT_E: 项目管理 */}
            <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />

            {/* 审计日志 (admin only) */}
            <Route path="/audit-logs" element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
}
